<template>
  <!-- <video-player  class="video-player vjs-custom-skin"
                 ref="videoPlayer"
                 :playsinline="true"
                 @play="onPlayerPlay($event)"
                 :options="playerOptions"
  ></video-player> -->

  <div class="video">
    <div class="video-content" :class="{isLineMobile: mobile && isLineFile}" style="background-color: #000;">
      <video :src="url" style="width:217px;height: 100%;"></video>

      <div class="play-mark">
        <div class="play" @click.stop="isShowPlay = true">
          <img :src="videoIcon" alt="">
        </div>
      </div>

    </div>


    <el-dialog :width="width" top="60px" custom-class="video-play--dialog" destroy-on-close append-to-body :visible.sync="isShowPlay">
      <video-player class="video-player vjs-custom-skin"
                    :class="`playbackControl-${playbackControl}`"
                    ref="videoPlayer"
                    :playsinline="true"
                    @play="onPlayerPlay($event)"
                    :options="playerOptions"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import videoIcon from '@/assets/images/video.png'
import 'video.js/dist/video-js.css'
// import 'video.js/src/cs'
import 'vue-video-player/src/custom-theme.css'
import { videoPlayer } from 'vue-video-player'

export default {
  name: 'video-play',
  components: {
    videoPlayer
  },
  props: {
    url: {
      type: String,
      default: '',
      require: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isLineFile: {
      type: Boolean,
      default: false
    },
    playbackControl: {
      type: String,
      default: '0'
    }
  },
  watch: {
    url: {
      handler() {
        // this.isPlay = false
        this.playerOptions.sources[0].src = this.url
      },
      immediate: true
    }
  },
  data() {
    return {
      isShowPlay: false,
      videoIcon,
      isPlay: false,
      playTime: 0,
      playDuration: '00:00',
      playCurrentTime: '00:00',
      totalDuration: 0,
      isShowControls: false,

      width: '50%',

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: '' //url地址
        }],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      }
    }
  },
  created() {
    let os = function() {
      let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
          /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
      }
    }()
    if (os.isAndroid || os.isPhone) {
      // 手机
      console.log('手机')
      this.width = '100%'
    } else if (os.isTablet) {
      // 平板
      this.width = '100%'
    }
  },
  methods: {
    onPlayerPlay(e) {
      let currentVideo = e.el_.children[0].getAttribute('id', 64)
      let videoList = document.getElementsByTagName('video')
      for (let i = 0; i < videoList.length; i++) {
        let id = videoList[i].getAttribute('id')
        if (currentVideo != id) {
          videoList[i].pause()
        }
      }

      let audio = document.querySelectorAll('audio')
      if (audio && audio.length) audio.forEach(i => i.pause());

      this.$emit('play')
    }
  }
}
</script>

<style scoped lang="scss">

.video-play--dialog {

}
::v-deep .el-dialog__header {
  padding: 10px;
}
.video-content {
  width: 190px;
  height: 164px;
  border-radius: 6px;
  overflow: hidden;
  position: relative;

  &.isLineMobile {
    width: 80px;
    height: 55px;
  }

  .play-mark {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0,0,0, .5);
    .play {
      position: absolute;
      left: 50%;
      top: 50%;
      cursor: pointer;
      transform: translateX(-50%) translateY(-50%);
    }
  }


}

.video-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);

  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50% -50%);
    display: block;
  }

}

.video-player {
  //width: 520px;
  //max-width: 100%;
  width: 100%;
}

.playbackControl-1 {
  ::v-deep .vjs-progress-control{
    pointer-events: none !important;
  }
}
</style>
